<template>
  <div class="top-bar">
    <span class="btn-add" @click="clickAddButton">+新增</span>
    <el-select
      class="select"
      :placeholder="placeholder"
      v-if="isShowSelect"
      v-model="selectValue"
      size="small"
      @change="selectChange()"
      :clearable="clearable"
    >
      <el-option
        v-for="item in data"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "topBar",
  props: [ "isShowSelect", "placeholder", "data", "clickAddButton", 'selectValues' ,'clearable'],
  data() {
    return {
      selectValue: ''
    }
  },
  created() {
    // this.selectValue=this.selectValues
  },
  watch:{
    selectValues(data) {

      this.selectValue = data.value

      this.$emit('getDefaultValue',data)
    },
    data(val) {

    }
  },
  methods: {
    selectChange() {

      this.$emit('selectChange', this.selectValue)
    }
  }
}
</script>

<style scoped lang="scss">
.top-bar {
  background: white;
  padding: 22px 20px;
  border-radius: 4px;
  min-width: 1000px;
  cursor: pointer;
  .select {
    margin-top: 20px !important;
    margin-right: 0px;
    margin-bottom: 0px;
  }
}
</style>
